var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.match` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.match
defineWellKnownSymbol('match');



//////////////////
// WEBPACK FOOTER
// ./~/core-js/modules/es.symbol.match.js
// module id = 1296
// module chunks = 1